import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pwr',
  pure: true
})
export class BatteryStatusPipe implements PipeTransform {
  transform(value: string | number | null): string {
    // null battery status means no battery
    if (value == null) {
      return 'deviceInfo_No_Battery';
    }
    // -1 means Charging
    else if (Number(value) == -1) {
      return 'deviceInfo_Battery_Charging';
    }
    // pure number, format with a percentage sign
    else if (typeof value === "number" || this.isNumeric(value)) {
      return 'deviceInfo_Battery_Status';
    }
    // otherwise it is already already a battery status
    else {
      return value;
    }
  }

  private isNumeric(value: string): boolean {
    return !isNaN(Number(value)) && value.trim() === Number(value).toString();
  }
}